<script lang="ts">
    import tagIcon from "../../assets/tag.svg?raw";
    import searchIcon from "../../assets/search.svg?raw";

    export let submitWordSearch;
    export let submitTagSearch;
    export let searchableTags;

    $: showAutocomplete = userQuery !== "";
    let autocompleteTags = [];
    let userQuery = "";
    let currentlyHoveredElement = 0;

    export function close() {
        userQuery = "";
        currentlyHoveredElement = 0;
    }

    export function handleUserTyped(searchBar: HTMLInputElement) {
        userQuery = searchBar.value;
        const searchVal = userQuery.toLowerCase();
        if (searchVal == "") {
            autocompleteTags = [];
            return;
        }
        autocompleteTags = Array.from(
            searchableTags.filter((tag) =>
                tag.toLowerCase().includes(searchVal),
            ),
        );
        // If we're hovering over a tag, and then the autocomplete shortens because we're typing
        // and there are fewer options, we don't want to keep hovering on it.
        if (currentlyHoveredElement > autocompleteTags.length) {
            // Remember that these are just the tags, so we'll always have a zeroeth element which is the string search.
            currentlyHoveredElement = autocompleteTags.length;
        }
    }

    // Returns false if the event shouldn't bubble
    export function handleKeyDown(evt: KeyboardEvent): boolean {
        // This +1 is for the raw search string
        const possibleValuesToComplete = autocompleteTags.length + 1;

        const submitSearch = () => {
            if (
                currentlyHoveredElement <= 0 ||
                currentlyHoveredElement === undefined
            ) {
                submitWordSearch();
            } else {
                submitTagSearch(autocompleteTags[currentlyHoveredElement - 1]);
            }
            currentlyHoveredElement = 0;
        };
        // Key values reference: https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
        switch (evt.key) {
            case "ArrowDown":
                currentlyHoveredElement =
                    (currentlyHoveredElement + 1) % possibleValuesToComplete;
                evt.preventDefault();
                return false;
            case "ArrowUp":
                // For some reason, -1 % 2 = -1
                if (currentlyHoveredElement === 0) {
                    currentlyHoveredElement = possibleValuesToComplete - 1;
                } else {
                    currentlyHoveredElement = currentlyHoveredElement - 1;
                }
                evt.preventDefault();
                return false;
            case "Submit":
                submitSearch();
                evt.preventDefault();
                return false;
            case "Enter":
                submitSearch();
                evt.preventDefault();
                return false;
            case "Tab":
                submitSearch();
                evt.preventDefault();
                return false;
            default:
                // The event wasn't handled. Bubble up.
                return true;
        }
    }

    function handleHover(idx: number) {
        currentlyHoveredElement = idx;
    }
</script>

{#if showAutocomplete}
    <div class="autocomplete">
        <div
            class="link padding-5px"
            class:selected={currentlyHoveredElement === 0}
            on:click={() => submitWordSearch()}
            on:pointerenter={() => handleHover(0)}
        >
            <div
                class="width-1rem pico-color"
                class:selected={currentlyHoveredElement === 0}
            >
                {@html searchIcon}
            </div>
            "{userQuery}"
            <div class="blue" class:invisible={currentlyHoveredElement !== 0}>
                <em>Press Enter or click</em>
            </div>
        </div>
        {#each autocompleteTags as tag, tagIdx (tag)}
            <div
                class="link padding-5px"
                class:selected={currentlyHoveredElement === tagIdx + 1}
                on:click={() => submitTagSearch(tag)}
                on:pointerenter={() => handleHover(tagIdx + 1)}
            >
                <div
                    class="width-1rem pico-color"
                    class:selected={currentlyHoveredElement === tagIdx + 1}
                >
                    {@html tagIcon}
                </div>
                {tag}
                <div
                    class="blue"
                    class:invisible={currentlyHoveredElement !== tagIdx + 1}
                >
                    <em>Press Enter or click</em>
                </div>
            </div>
        {/each}
    </div>
{/if}
